import MiradorComparePlugin from './MiradorCompare';

export {
  MiradorComparePlugin,
};

export default [
  MiradorComparePlugin,
];
